var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#CDF6F9;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#1A83A8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Money"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Receipt"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Chart"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Briefcase"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Coin"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Tax"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Vision"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Contract"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Book"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Financial"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Payment_day"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Report"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Loss"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Profit"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Money_Bag"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Target"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Gold"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Safety_Box"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Wallet"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Investment"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Pie_Chart"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Home"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Assets"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "25.648,2 28.29,6.002 21.045,14.299 13.8,6.002 16.442,2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.52,18.61v9.97c0,0.79-0.63,1.42-1.41,1.42H4.7c-1.13,0-2.06-0.92-2.06-2.06v-8.69   c0-1.14,0.93-2.06,2.06-2.06h2.41C7.89,17.19,8.52,17.83,8.52,18.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.65,24.21L26,26.75c-0.78,0.76-1.75,1.28-2.81,1.52l-4.88,1.12c-0.93,0.22-1.89,0.21-2.81-0.03L8.52,27.6   v-7.34l2.21-1.5c1.35-0.92,3.01-1.25,4.61-0.91l4.32,0.9c1.06,0.23,1.82,1.16,1.82,2.24c0,0.63-0.26,1.21-0.67,1.62   c-0.42,0.41-0.99,0.67-1.62,0.67h1.61c0.44,0,0.88-0.13,1.25-0.37l3.66-2.39c0.93-0.6,2.15-0.45,2.91,0.35l0.11,0.11   C29.59,21.9,29.56,23.34,28.65,24.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20.367,14.891c0.171,0.196,0.418,0.309,0.678,0.309s0.507-0.112,0.678-0.309l7.245-8.297   c0.267-0.305,0.296-0.75,0.073-1.088l-2.642-4.002C26.233,1.252,25.951,1.1,25.648,1.1h-9.206c-0.303,0-0.584,0.152-0.751,0.404   l-2.643,4.002c-0.223,0.338-0.193,0.783,0.073,1.088L20.367,14.891z M17.606,6.902l1.145,3.401l-2.97-3.401H17.606z M22.095,2.9   l0.582,2.201h-3.265L19.995,2.9H22.095z M26.308,6.902l-2.97,3.401l1.145-3.401H26.308z M22.585,6.902l-1.54,4.575l-1.54-4.575   H22.585z M26.617,5.102H24.54L23.957,2.9h1.207L26.617,5.102z M16.927,2.9h1.206L17.55,5.102h-2.077L16.927,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.387,20.368l-0.109-0.117c-1.06-1.119-2.766-1.323-4.059-0.48l-2.915,1.9   c0.048-0.219,0.076-0.444,0.076-0.677c0-1.5-1.065-2.813-2.534-3.121l-4.322-0.907c-1.825-0.383-3.758-0.001-5.299,1.048   l-0.807,0.549c-0.026-1.255-1.05-2.269-2.312-2.269H4.703c-1.633,0-2.961,1.328-2.961,2.96v8.688c0,1.632,1.328,2.96,2.961,2.96   h2.402c1.22,0,2.211-0.95,2.299-2.148l5.873,1.484c0.553,0.139,1.122,0.209,1.691,0.209c0.519,0,1.038-0.059,1.543-0.175   l4.876-1.119c1.217-0.278,2.337-0.883,3.237-1.749l2.65-2.546C30.535,23.647,30.584,21.634,29.387,20.368z M7.621,28.584   c0,0.284-0.231,0.516-0.516,0.516H4.703c-0.64,0-1.16-0.52-1.16-1.159v-8.688c0-0.64,0.521-1.159,1.16-1.159h2.402   c0.284,0,0.516,0.231,0.516,0.516V28.584z M28.03,23.558l-2.651,2.547c-0.666,0.64-1.493,1.087-2.393,1.293l-4.876,1.119   c-0.783,0.181-1.611,0.173-2.392-0.026l-6.297-1.591v-6.165l1.815-1.233c1.139-0.775,2.569-1.057,3.917-0.774l4.321,0.907   c0.64,0.134,1.104,0.706,1.104,1.359c0,0.766-0.622,1.389-1.388,1.389H16.21c-0.497,0-0.9,0.403-0.9,0.9s0.403,0.9,0.9,0.9h4.59   c0.618,0,1.221-0.18,1.741-0.519l3.66-2.386c0.564-0.368,1.307-0.279,1.767,0.207l0.109,0.117   C28.6,22.154,28.578,23.031,28.03,23.558z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Computer"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.b523cedfae67f2ead8fb3137225e3199.svg";
export { ForwardRef as ReactComponent };